import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const schedulerSchema: Schema = {
  title: 'Scheduler',
  level: 2,
  columns: commonColumns
}
